import React, { FC } from 'react';
import styles from './index.less';
import { Col, message, Row, Switch } from 'antd';
import ImageModuleUpload from './ImageModuleUpload';
import ImageModuleCardTitle from '@/pages/backend/cardCampSettings/recruitPageSettings/ImageModuleCardTitle';
import { InboxOutlined } from '@ant-design/icons';

type ImageModuleProps = {
  id: number;
  mode?: 'dynamicCommunication' | 'promotionalImages';
  name: string;
  onDelete: (id: number) => void;
  onChecked: (id: number, checked: boolean) => void;
  onUrlChange: (id: number, type: 'pcUrl' | 'mobileUrl', url?: string) => void;
  onNameChange: (id: number, name: string) => boolean;
  pcUrl?: string;
  mobileUrl?: string;
  checked?: boolean;
};

const ImageModule: FC<ImageModuleProps> = (props) => {
  const {
    checked,
    onNameChange,
    mobileUrl,
    pcUrl,
    onDelete,
    id,
    mode = 'promotionalImages',
    name,
    onUrlChange,
    onChecked,
  } = props;

  return (
    <div className={styles.image_module} data-id={id}>
      <div className={styles.image_module_inner}>
        <ImageModuleCardTitle
          showEditIcon={mode === 'promotionalImages'}
          onDelete={onDelete}
          onDeleteSuccess={() => {
            message.success('宣传图模块已删除');
          }}
          rightCom={
            mode === 'dynamicCommunication' ? (
              <Switch
                checked={checked}
                onChange={(value) => {
                  onChecked(id, value);
                }}
              />
            ) : undefined
          }
          fixName={mode === 'dynamicCommunication' ? '交流动态' : undefined}
          id={id}
          name={name}
          onNameChange={onNameChange}
        />
        <div className={styles.image_module_inner_body}>
          {mode === 'dynamicCommunication' ? (
            <div className="text-8d8d8d">
              会在招生页展示打卡营下所有批次的交流动态区内容。建议在有一定数量的内容后再开启
            </div>
          ) : (
            <Row gutter={12}>
              <Col span={12}>
                <div>PC宣传图</div>
                <ImageModuleUpload
                  uploadButton={
                    <div className="ant-upload-drag-container">
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">点击或拖拽文件到此处上传</p>
                      <p className="ant-upload-hint">
                        支持上传文件大小不超过2MB的.png\.jpg格式文件
                      </p>
                      <p className="ant-upload-hint">图片宽度为1200px，高度不限</p>
                    </div>
                  }
                  className={styles.image_module_mobileimg}
                  // url={pcUrl}
                  value={pcUrl}
                  onChange={(url) => {
                    onUrlChange(id, 'pcUrl', url);
                  }}
                />
              </Col>
              <Col span={12}>
                <div>移动宣传图</div>
                <ImageModuleUpload
                  value={mobileUrl}
                  className={styles.image_module_mobileimg}
                  // url={mobileUrl}
                  onChange={(url) => {
                    onUrlChange(id, 'mobileUrl', url);
                  }}
                />
              </Col>
            </Row>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageModule;
